import { List, theme } from 'antd'
import React from 'react'
import { SearchResponse } from '../../api'
import { SearchProps } from '../../components/search'
import { useTranslation } from 'react-i18next'
import { CandidateLink } from './candidate-link'
import { CandidateAvatar } from './candidate-avatar'

export type CandidateSearchListProps = {
    candidates: SearchResponse['candidates']
} & Pick<SearchProps, 'onCancel'>

export function CandidateSearchList({ candidates, onCancel }: CandidateSearchListProps) {
    const { token } = theme.useToken()
    const { t } = useTranslation()

    return (
        <List
            header={<span style={{ padding: `0 ${token.paddingMD}px` }}>{t('Candidates')}</span>}
            dataSource={candidates}
            renderItem={(candidate) => {
                return (
                    <CandidateLink
                        id={candidate.id}
                        campaignId={candidate.campaignId}
                        status={candidate.status}
                        onClick={onCancel}
                    >
                        <List.Item
                            tabIndex={0}
                            style={{
                                padding: `${token.paddingSM}px ${token.paddingMD}px`,
                            }}
                            className="cursor-pointer"
                            extra={candidate.status === 'finished' ? t('Finished') : t('Ongoing')}
                        >
                            <List.Item.Meta
                                avatar={<CandidateAvatar candidate={candidate} />}
                                title={candidate.name}
                                description={
                                    <>
                                        {candidate.campaignTitle} <br /> {candidate.phone}
                                    </>
                                }
                            />
                        </List.Item>
                    </CandidateLink>
                )
            }}
        />
    )
}
